import React, { Component } from 'react'
import { Button, Card, Icon, Grid, Image } from 'semantic-ui-react'
import MediaButton from '../../../MediaButton'

class IntroBlock extends Component {
  constructor (props) {
    super(props)

    this.state = {
      id: null,
      type: 'slider_block',
      slides: [
        { img_desktop: null, img_mobile: null }
      ]
    }

    this.handleChange = this.handleChange.bind(this)
  }

  componentWillMount() {
    if (this.props.obj) {
      this.setState({
        id: this.props.obj.id,
        slides: this.props.obj.slides
      })
    }
  }

  handleChange (event) {
    let newState = {
      slides: [...this.state.slides]
    }

    if (event.target.files && event.target.files.length > 0) {
      //files
      newState.obj[event.target.id] = event.target.files[0]
    } else {
      //simple data
      newState.obj[event.target.id] = event.target.value
    }

    this.setState(newState)
  }

  handleClick = (e) => {
    e.preventDefault()
    this.setState({
      slides: [...this.state.slides, { img_desktop: null, img_mobile: null }]
    })
  }

  handleInsertImage = (e, media, language, id, type) => {
    if (media) {
      let gallery = [...this.state.slides].map((slide, i) => {
        if (i === id) {
          const s = {...slide}
          s[type] = media.file
          return s
        }

        return slide
      })

      this.setState({
        slides: gallery
      })
    }
  }

  handleDelete = (e, i) => {
    let gallery = [...this.state.slides]
    gallery.splice(i, 1)
    this.setState({
      slides: gallery
    })
  }

  handleMoveSlide = (sort, index) => {
    const gallery = [...this.state.slides]
    if (sort === 'up') {
      if (index !== 0) {
        const tmp = gallery[index - 1]
        gallery[index - 1] = gallery[index]
        gallery[index] = tmp
      }
    } else {
      if (index !== this.state.slides.length) {
        const tmp = gallery[index + 1]
        gallery[index + 1] = gallery[index]
        gallery[index] = tmp
      }
    }

    this.setState({
      slides: gallery
    })
  }

  getValues = () => {
    return this.state
  }

  renderCardMedia = (image, label, id, type) => {
    return (
      <Card fluid>
        { image && <Image src={image} /> }
        <Card.Content>
          <MediaButton fluid={true} icon='upload' name='' label={label} id={id} type={type} handleClick={this.handleInsertImage}></MediaButton>
        </Card.Content>
      </Card>
    )
  }

  renderSlide = (image, i) => {
    return (
      <Grid key={i} columns={4}>
        <Grid.Row>
          <Grid.Column>
            {i !== 0 && <div><Button icon onClick={(e) => {this.handleMoveSlide('up', i)}}><Icon name='arrow up' /></Button><br/><br/></div>}
            {this.state.slides.length - 1 !== i && <Button icon onClick={(e) => {this.handleMoveSlide('down', i)}}><Icon name='arrow down' /></Button>}
          </Grid.Column>
          <Grid.Column>
            {this.renderCardMedia(image.img_desktop, 'Image (Desktop)', i, 'img_desktop')}
          </Grid.Column>
          <Grid.Column>
            {this.renderCardMedia(image.img_mobile, 'Image (Mobile)', i, 'img_mobile')}
          </Grid.Column>
          <Grid.Column>
            <Button icon color='red' onClick={(e) => { this.handleDelete(e, i) }}><Icon name="delete" /></Button>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }

  renderSlides = () => {
    return this.state.slides.map((slide, i) => {
      return this.renderSlide(slide, i)
    })
  }

  render () {
    const { onDelete } = this.props

    return (
      <Card fluid>
        <Card.Content>
          <Card.Header>
            Bloc slider
            <Button size='mini' floated='right' icon color='red' type='submit' onClick={onDelete}><Icon name="delete" /></Button>
            {/* {index !== max - 1 && <Button size='mini' floated='right' icon onClick={(e) => { onMoveBlock('down', index) }}><Icon name="arrow down" /></Button>}
            {index !== 0 && <Button size='mini' floated='right' icon onClick={(e) => { onMoveBlock('up', index) }}><Icon name="arrow up" /></Button>} */}
            <Button size='mini' floated='right' onClick={this.handleClick}><Icon name="sliders" /> Ajouter un slide</Button>
          </Card.Header>
        </Card.Content>
        <Card.Content>
          <Card.Description>
            {this.renderSlides()}
          </Card.Description>
        </Card.Content>
      </Card>
    )
  }
}

export default IntroBlock



// WEBPACK FOOTER //
// ./src/components/form/pageBuilder/blocks/slider_block.js